import { z } from 'zod';
import { parseFiniteNumber } from '../../parse-finite-number.js';
import { PURCHASE_ORDER_CONSTRAINTS } from './constraints.js';
// Upper bound stays well under the Decimal(28,9) column's overflow point.
export const purchaseOrderUnitCostBoundsSchema = z
    .number()
    .min(0, `${PURCHASE_ORDER_CONSTRAINTS.unitCost.label} must be a non-negative number.`)
    .max(1_000_000_000, `${PURCHASE_ORDER_CONSTRAINTS.unitCost.label} must be 1,000,000,000 or less.`);
export function parsePurchaseOrderUnitCost(value, label) {
    const trimmed = value.trim();
    if (!trimmed) {
        return null;
    }
    const parsed = parseFiniteNumber(trimmed);
    if (parsed === undefined) {
        return `${label} must be a non-negative number.`;
    }
    const result = purchaseOrderUnitCostBoundsSchema.safeParse(parsed);
    if (!result.success) {
        return result.error.issues[0]?.message ?? `${label} is invalid.`;
    }
    return parsed;
}
//# sourceMappingURL=item-unit-cost.js.map